import { render, staticRenderFns } from "./o-modal.vue?vue&type=template&id=55b548ce&scoped=true&"
import script from "./o-modal.vue?vue&type=script&lang=js&"
export * from "./o-modal.vue?vue&type=script&lang=js&"
import style0 from "./o-modal.vue?vue&type=style&index=0&id=55b548ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b548ce",
  null
  
)

export default component.exports